import { FULL_FEEDBACK, FULL_NOTIFICATION, READ_FLAG } from '../../types';
import {
  queryRepairServiceDetails,
  querySysAnnouncementSend,
  queryUserAnnouncementSend,
  updateMarkAllRecordsReaded,
  updateSysAnnouncementReadAll,
  updateSysAnnouncementSend,
} from '../../../_db/api.service';
import { toastError, toastSuccess } from '../../../components/toastify';


// 消息通知List彈框
export const toggleNotificationListDrawer = (visible) => async (dispatch, getState) => {
  dispatch({
    type: FULL_NOTIFICATION.ListDrawer,
    payload: visible
  });
  dispatch(queryUnreadNotificationTotal());
};

// 消息通知Details彈框
export const toggleNotificationDetailsDrawer = (visible) => async (dispatch, getState) => {
  dispatch({
    type: FULL_NOTIFICATION.DetailsDrawer,
    payload: visible
  });
};

// 是否存在未讀通知
export const queryUnreadNotificationTotal = () => async (dispatch, getState) => {
  const { success: success1, result: result1, message: message1 } = await querySysAnnouncementSend({ readFlag: READ_FLAG.Unread, pageNo: 1, pageSize: 3 });
  const { success: success2, result: result2, message: message2 } = await queryUserAnnouncementSend({ isRead: READ_FLAG.Unread, pageNo: 1, pageSize: 3 }); 
  const { total: total1 } = result1 || {};
  const { total: total2 } = result2 || {};
  // if (success) {
    dispatch({
      type: FULL_NOTIFICATION.UnreadAllTotal,
      payload: total1 + total2
    });
  // }
  dispatch({
    type: FULL_NOTIFICATION.UnreadTotal,
    payload: total1
  });

  dispatch({
    type: FULL_FEEDBACK.UnreadTotal,
    payload: total2
  });
};

// 系統通知列表
export const querySystemNotificationList = ({ page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  const { slices: { notification } } = await getState();
  dispatch({
    type: FULL_NOTIFICATION.List,
    payload: {
      ...notification,
      isLoading: true
    }
  });

  const { success, result, message } = await  querySysAnnouncementSend({ pageNo: page, pageSize: rowsPerPage });
  const { records, current, pages, size, total } = result || {};
  // if (success) {
    dispatch({
      type: FULL_NOTIFICATION.List,
      payload: {
        list: records,
        total,
        page: current,
        rowsPerPage: size,
        pages,
        isLoading: false
      }
    });
  // }
};


// 系統通知詳情
export const querySysNotificationDetails = (record) => async (dispatch, getState) => {
  const { slices: { notification } } = await getState();
  const { success } = await updateSysAnnouncementSend({anntId: record?.anntId});
  dispatch(toggleNotificationDetailsDrawer(true));
  dispatch({
    type: FULL_NOTIFICATION.Details,
    payload: notification?.list?.find(item => [record?.id].includes(item?.id))
  });

  if([READ_FLAG.Unread].includes(Number(record?.readFlag))) {
    await dispatch(queryUnreadNotificationTotal());
    await dispatch(querySystemNotificationList({ page: notification?.page, rowsPerPage: notification?.rowsPerPage }));
  }
};

// 系統消息一鍵已讀
export const onSysNotificationArchived = (record) => async (dispatch, getState) => {
  const { slices: { notification } } = await getState();
  const { success, result, message } = await updateSysAnnouncementReadAll();
  if(success) {
    dispatch(queryUnreadNotificationTotal());
    dispatch(querySystemNotificationList({ page: notification?.page, rowsPerPage: notification?.rowsPerPage }));
    toastSuccess(message);
  }
};



// 個人通知列表
export const queryPersonalNotificationList = ({ page = 1, rowsPerPage = 10, readFlag = '' }) => async (dispatch, getState) => {

  const { slices: { notification } } = await getState();

  const { success, result, message } = await queryUserAnnouncementSend({ isRead: readFlag, pageNo: page, pageSize: rowsPerPage });
  const { records, current, pages, size, total } = result || {};
  // if (success) {
    dispatch({
      type: FULL_NOTIFICATION.List,
      payload: {
        list: records,
        total,
        page: current,
        rowsPerPage: size,
        pages,
        isLoading: false
      }
    });
  // }
};

// 個人通知詳情
export const queryUserNotificationDetails = (record) => async (dispatch, getState) => {
  const { slices: { notification } } = await getState();
  const { success, result, message } = await queryRepairServiceDetails(record);

  if(success) {
    dispatch(toggleNotificationDetailsDrawer(true));
    
    dispatch({
      type: FULL_NOTIFICATION.Details,
      payload: result
    });

    if([READ_FLAG.Unread].includes(Number(record?.isRead))) {
      await dispatch(queryUnreadNotificationTotal());
      await dispatch(queryPersonalNotificationList({ page: notification?.page, rowsPerPage: notification?.rowsPerPage }));
    };
    return;
  }
  toastError(message);
};

// 個人消息一鍵已讀
export const onUserNotificationArchived = (params) => async (dispatch, getState) => {
  const { slices: { notification } } = await getState();
  const { success, result, message } = await updateMarkAllRecordsReaded(params);
  if(success){
    // 更新個人通知
    dispatch(queryUnreadNotificationTotal());
    dispatch(queryPersonalNotificationList({ page: notification?.page, rowsPerPage: notification?.rowsPerPage }));
    toastSuccess(message);
  }
};